import { Injectable } from "@angular/core";
import { DisplayTime } from "./account/model";

@Injectable()
export class TimeService {
  nbrSixty: number = 60;
  defaultTimeInMin: number = 20;

  getDisplayTime(sliderTime: number): DisplayTime {
    let selectedTimeInMin: number;
    selectedTimeInMin = Math.ceil(this.convertHoursToMin(sliderTime));
    let divForMinutes = selectedTimeInMin % this.nbrSixty;
    let minutes = Math.ceil(divForMinutes);
    let displayTime = new DisplayTime();
    displayTime.hours = Math.floor(this.convertMinToHours(selectedTimeInMin));
    displayTime.minutes = minutes;
    return displayTime;
  }

  convertHoursToMin(hours: number): number {
    return hours * this.nbrSixty;
  }

  convertMinToHours(minutes: number): number {
    return minutes / this.nbrSixty;
  }

  getMFAStatus(mfaEnabled: boolean): string {
    let status = mfaEnabled ? "Enabled" : "Disabled";
    return "Mfa" + status;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/time.service.ts